import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, Button, Input, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { useRef } from "react";
import { useState } from "react";
import { Trans } from "react-i18next";

/**
 * Renders the participant input
 * 
 * @param {Object} props The props of the component
 * @returns The participant input
 */
const ParticipantInput = ({ isOpen, onSubmit, onClose }) => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const cancelRef = useRef();

    return (
        <AlertDialog
            isOpen={isOpen}
            leastDestructiveRef={cancelRef}
            onClose={onClose}
        >
            <AlertDialogContent>
                <AlertDialogHeader>
                    <Trans>plugin.addParticipant.title</Trans>
                </AlertDialogHeader>
                <AlertDialogBody>
                    <VStack gap={"20px"}>
                        <Text>
                            <Trans>plugin.addParticipant.description_add</Trans>
                        </Text>
                        <Input type="tel" placeholder="+XXXXXXXXXXX" value={phoneNumber} onChange={(event) => setPhoneNumber(event?.target?.value)} />
                    </VStack>
                </AlertDialogBody>
                <AlertDialogFooter>
                    <Button colorScheme="gray" borderRadius={"10px"} ref={cancelRef} onClick={onClose}>
                        <Trans>plugin.addParticipant.cancel</Trans>
                    </Button>
                    <Button colorScheme="red" backgroundColor={"#E57672"} borderRadius={"10px"} onClick={() => {
                        onSubmit(phoneNumber);
                        setPhoneNumber("");
                    }} ml={3}>
                        <Trans>plugin.addParticipant.confirm</Trans>
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}

export default React.memo(ParticipantInput);